<template>
  <div>

    <!-- Untersuchungsdatum -->

    <div class="flex-gt-sm-33 flex-100 px-2">
      <validation-provider tag="div"
                           :name="path + '.untersuchungsdatum_verlauf'"
                           :ref="path + '.untersuchungsdatum_verlauf'"
                           :rules="{required:true,german_date:true,date_not_in_future:true,date_must_be_greater_than_diagnosis:diagDate,date_must_be_lesser_than_death:[deathDate,null]}"
                           v-slot="{ errors }">
        <lx-datepicker
            :color="compColor.textInput"
            :auto-focus="!formId"
            :name="path + '.untersuchungsdatum_verlauf'"
            :label="$t('FORMS_DIVERSE.BASE_PROGRESS_DATE') + ' *'"
            class="mb-4"
            :disabled="isDisabled"
            :hide-details="!errors || errors.length <= 0"
            :dense="denseFields"
            :error="errors[0]"
            v-model="model.untersuchungsdatum_verlauf"
        ></lx-datepicker>
      </validation-provider>
    </div>

    <!-- Gesamtbeurteilung Tumorstatus -->

    <div class="flex-gt-sm-66 flex-100 px-2">
      <validation-provider tag="div"
                           class="layout-row"
                           :name="path + '.gesamtbeurteilung_tumorstatus'"
                           :ref="path + '.gesamtbeurteilung_tumorstatus'"
                           :rules="{required: true, tumor_state_overall: [model.verlauf_lokaler_tumorstatus, model.verlauf_tumorstatus_lymphknoten, model.verlauf_tumorstatus_fernmetastasen, diagCode]}"
                           v-slot="{ errors }">

        <v-tooltip bottom open-delay="1000" max-width="800">
          <template v-slot:activator="{ on }">
            <div v-on="on" class="layout-row layout-align-start-start mr-2" :class="{'mt-2': denseFields, 'mt-3': !denseFields}"
                 style="cursor: pointer;">
              <v-icon :color="compColor.prime" medium>info</v-icon>
            </div>
          </template>

          <div class="px-2">
            <p style="text-align: justify;" class="my-1">{{ $t('FORMS_DIVERSE.INFO_BASE_PROGRESS_OVERALL_ASSESSMENT_TUMOR') }}</p>
          </div>
        </v-tooltip>

        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.BASE_PROGRESS_OVERALL_ASSESSMENT_TUMOR') + ' *'"
          v-model="model.gesamtbeurteilung_tumorstatus"
          :items="TumorStatusGeneralTypes"
          outlined
          @change="setDefaultValuesOfStates(model.gesamtbeurteilung_tumorstatus)"
          :disabled="isDisabled"
          :hide-details="!errors || errors.length <= 0"
          :dense="denseFields"
          :error-messages="errors[0]"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item.text }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
    </div>

    <!-- Tumorstatus Primärtumor -->

    <div class="flex-gt-sm-33 flex-100 px-2">
      <validation-provider tag="div"
                           :name="path + '.verlauf_lokaler_tumorstatus'"
                           :ref="path + '.verlauf_lokaler_tumorstatus'"
                           rules=""
                           v-slot="{ errors }">
        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.BASE_PROGRESS_PROGRESS_LOCALE_TUMOR')"
          v-model="model.verlauf_lokaler_tumorstatus"
          :items="TumorStatusLokalTypes"
          outlined
          clearable
          @change="triggerTNMDefaultSettingOnParent('verlauf_lokaler_tumorstatus')"
          :hide-details="!errors || errors.length <= 0"
          :disabled="isDisabled"
          :dense="denseFields"
          :error-messages="errors[0]"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item.text }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
    </div>

    <!-- Tumorstatus Lymphknoten -->

    <div class="flex-gt-sm-33 flex-100 px-2">
      <validation-provider tag="div"
                           :name="path + '.verlauf_tumorstatus_lymphknoten'"
                           :ref="path + '.verlauf_tumorstatus_lymphknoten'"
                           rules=""
                           v-slot="{ errors }">
        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.BASE_PROGRESS_STATE_LYMPH_NODES')"
          v-model="model.verlauf_tumorstatus_lymphknoten"
          :items="TumorStatusLymphNodesTypes"
          outlined
          clearable
          @change="triggerTNMDefaultSettingOnParent('verlauf_tumorstatus_lymphknoten')"
          :hide-details="!errors || errors.length <= 0"
          :disabled="isDisabled"
          :dense="denseFields"
          :error-messages="errors[0]"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item.text }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
    </div>

    <!-- Tumorstatus Fernmetastasen -->

    <div class="flex-gt-sm-33 flex-100 px-2">
      <validation-provider tag="div"
                           :name="path + '.verlauf_tumorstatus_fernmetastasen'"
                           :ref="path + '.verlauf_tumorstatus_fernmetastasen'"
                           rules=""
                           v-slot="{ errors }">
        <v-select
          :color="compColor.primeColor"
          :label="$t('FORMS_DIVERSE.BASE_PROGRESS_DISTANT_METASTASIS')"
          v-model="model.verlauf_tumorstatus_fernmetastasen"
          :items="TumorStatusMetastasesTypes"
          outlined
          clearable
          @change="setDefaultValuesMetastasis(model.verlauf_tumorstatus_fernmetastasen)"
          :disabled="isDisabled"
          :hide-details="!errors || errors.length <= 0"
          :dense="denseFields"
          :error-messages="errors[0]"
          :menu-props="{ bottom: true, offsetY: true }"
          :dark="compColor.isInDarkMode">
          <template v-slot:item="{ item, on, attrs }">
            <v-list-item v-on="on"
                         :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
              <v-list-item-content class="py-0">
                <label style="cursor:pointer;"
                       :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                       class="lighten-4 text--darken-2">{{ item.text }}</label>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
      </validation-provider>
    </div>

    <div class="layout-wrap flex-gt-sm-100 flex-100 mb-4 mx-2"
         v-if="model.gesamtbeurteilung_tumorstatus === 'P' && model.verlauf_tumorstatus_fernmetastasen === 'R'">
      <lx-alert-box color="orange">
        <span>{{ $t('FORMS_DIVERSE.WARNING_PROGRESS_WITH_DISTANCE_METASTASIS.PART_ONE') }}</span>
        <span class="font-weight-bold">{{ $t('FORMS_DIVERSE.WARNING_PROGRESS_WITH_DISTANCE_METASTASIS.PART_TWO') }}</span>
        <span>{{ $t('FORMS_DIVERSE.WARNING_PROGRESS_WITH_DISTANCE_METASTASIS.PART_THREE') }}</span>
      </lx-alert-box>
    </div>
  </div>
</template>

<script>
import metaData from '../shared/formsMetaData'

export default {
  name: "Grunddaten_Verlauf",
  mixins: [metaData],
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    path: {
      type: String
    },
    isDisabled: {
      type: Boolean
    },
    patientId: {
      type: String
    },
    formId: {
      type: String
    }
  },
  data () {
    return {
      model: {},
      TumorStatusGeneralTypes: null,
      TumorStatusLokalTypes: null,
      TumorStatusLymphNodesTypes: null,
      TumorStatusMetastasesTypes: null
    }
  },
  created () {
    this.TumorStatusGeneralTypes = this.formsMetaData.TumorStatusGeneralTypes
    this.TumorStatusLokalTypes = this.formsMetaData.TumorStatusLokalTypes
    this.TumorStatusLymphNodesTypes = this.formsMetaData.TumorStatusLymphNodesTypes
    this.TumorStatusMetastasesTypes = this.formsMetaData.TumorStatusMetastasesTypes
  },
  methods: {
    /**
     * Trigger event in parent to set default values of tnm
     */
    triggerTNMDefaultSettingOnParent (value) {
      this.$emit('set-tnm-defaults', value)
    },

    /**
     * Set default values to sub-status after changing general state
     *
     * @param generalState
     */
    setDefaultValuesOfStates (generalState) {
      // complete remission, CR
      if (generalState === 'V_new' || generalState === 'V_cont') {
        this.$set(this.model, 'verlauf_lokaler_tumorstatus', 'K')
        this.$set(this.model, 'verlauf_tumorstatus_lymphknoten', 'K')
        this.$set(this.model, 'verlauf_tumorstatus_fernmetastasen', 'K')
      }

      // no change, NC(K), Unknown(U), missing specification(X)
      if (generalState === 'K' || generalState === 'U' || generalState === 'X') {
        this.$set(this.model, 'verlauf_lokaler_tumorstatus', 'U')
        this.$set(this.model, 'verlauf_tumorstatus_lymphknoten', 'U')
        this.$set(this.model, 'verlauf_tumorstatus_fernmetastasen', 'U')
      }

      // progression(P), partial remission(T)
      if (generalState === 'P' || generalState === 'T') {
        // diagnosis with C61, C8* or C9* needs no sub-status, when progression or partial-remission, then set substatus to "U"
        const matchDiagnosisRegex = RegExp(/^C61|C8|C9/)
        const isDiagnosisWithoutSuBStatus =  matchDiagnosisRegex.test(this.diagCode)

        if (isDiagnosisWithoutSuBStatus) {
          this.$set(this.model, 'verlauf_lokaler_tumorstatus', 'U')
          this.$set(this.model, 'verlauf_tumorstatus_lymphknoten', 'U')
          this.$set(this.model, 'verlauf_tumorstatus_fernmetastasen', 'U')
        } else {
          this.$set(this.model, 'verlauf_lokaler_tumorstatus', null)
          this.$set(this.model, 'verlauf_tumorstatus_lymphknoten', null)
          this.$set(this.model, 'verlauf_tumorstatus_fernmetastasen', null)
        }
      }

      // trigger default setting of tnm only after manually change of base data
      this.triggerTNMDefaultSettingOnParent('gesamtbeurteilung_tumorstatus')
    },

    /**
     * Set state values per default after changing metastasis-state to rezitiv
     *
     * @param state
     */
    setDefaultValuesMetastasis (state) {
      if (state === 'R') {
        this.$set(this.model, 'gesamtbeurteilung_tumorstatus', 'P')
      }

      // trigger default setting of tnm only after manually change of base data
      this.triggerTNMDefaultSettingOnParent('verlauf_tumorstatus_fernmetastasen')
    }
  },
  computed: {
    diagDate () {
      return this.patientId ? this.$store.getters.diagnosisBaseData(this.patientId).diagDate : undefined
    },
    diagCode () {
      return this.patientId ? this.$store.getters.diagnosisBaseData(this.patientId).diagCode : undefined
    },
    deathDate () {
      return this.patientId ? this.$store.getters.diagnosisBaseData(this.patientId).deathDate : undefined
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
        }
      },
      immediate: true
    }
  }
}
</script>
